export default __webpack_public_path__ + "static/media/reticulated.9f18e17b.webp";